// extracted by mini-css-extract-plugin
export default {"container":"kyCwKlwOazTQCojVIA_U","icon":"d0Dvd1ECpbcsFLLZvHHj"};